import { createFileRoute, useParams } from '@tanstack/react-router';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import calendar from 'dayjs/plugin/calendar';
import { useTranslation } from 'react-i18next';

import { ThreadDetailView } from '@/components/threads/ThreadDetailView';
import { normalizeThreadKey } from '@/components/threads/utils';
import { ClientScopeEmpty } from '@/components/client-portal/ClientScopeEmpty';
import { useClientPortalScope } from '@/hooks/useClientPortalScope';
import { useThreadDetail } from '@/hooks/threads/useThreadDetail';

dayjs.extend(relativeTime);
dayjs.extend(calendar);

export const Route = createFileRoute('/client/threads/$threadId')({
  component: ClientThreadDetailPage
});

function ClientThreadDetailPage() {
  const { t: tDashboard } = useTranslation('dashboard');
  const { threadId } = useParams({ from: '/client/threads/$threadId' });
  const portalScope = useClientPortalScope();
  const detail = useThreadDetail(normalizeThreadKey(threadId), { kind: 'client', ...portalScope });

  if (portalScope.isAdmin && !portalScope.adminScopeReady) {
    return <ClientScopeEmpty description={tDashboard('client.scopeRequired.thread')} />;
  }

  return <ThreadDetailView detail={detail} variant="client" simplifyForCustomer={portalScope.isCustomer} />;
}
